/**
 * Roles module constants
 */

export const ADD_ROLE = 'ADD_ROLE';
export const GET_ROLES = 'GET_ROLES';
export const GET_ROLE_BY_ID = 'GET_ROLE_BY_ID';
export const MODIFY_ROLE = 'MODIFY_ROLE';
export const SET_EDITING_ROLE = 'SET_EDITING_ROLE';
export const SET_ROLES_FILTERS = 'SET_ROLES_FILTERS';
export const SET_ROLES_PAGINATION = 'SET_ROLES_PAGINATION';
export const TOGGLE_ROLE = 'TOGGLE_ROLE';
export const UPDATE_ROLE = 'UPDATE_ROLE';



// WEBPACK FOOTER //
// src/modules/secured/modules/roles/constants/roles_constants.js